<script setup lang="ts">
  import { fetchAbbrString } from '@shared/utils/helpers'
  import { computed } from 'vue'

  const props = withDefaults(
    defineProps<{
      firstName?: string
      lastName?: string
      fullName?: string
      width?: number
      height?: number
      stringColor?: string
      isActive?: boolean
      nonActiveColor?: string
      hexColor?: string
      isCircle?: boolean
      isSmall?: boolean
      fontBold?: boolean
      noMargin?: boolean
    }>(),
    {
      firstName: '',
      lastName: '',
      fullName: '',
      width: 40,
      height: 40,
      stringColor: '',
      isActive: true,
      nonActiveColor: '',
      hexColor: '',
      isCircle: false,
      isSmall: false,
      fontBold: false,
      noMargin: false,
    }
  )

  const stringToHex = (string: string) => {
    if (props.hexColor) {
      return props.hexColor
    }
    let hash = 0
    for (let i = 0; i < string.length; i++) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash)
    }
    let color = '#'
    for (let i = 0; i < 3; i++) {
      const value = (hash >> (i * 8)) & 0xff
      color += ('00' + value.toString(16)).substr(-2)
    }
    return color
  }
  const abbr = computed(() => {
    if (props?.firstName && props?.lastName) {
      return fetchAbbrString(props.firstName, props.lastName)
    }
    if (props?.fullName) {
      return fetchAbbrString(props.fullName)
    }
    if (props?.firstName) {
      return fetchAbbrString(props.firstName)
    }
    return ''
  })
</script>

<template>
  <div
    class="tw-flex tw-justify-center tw-items-center tw-rounded-12 tw-text-subtitle-1 tw-text-white"
    :class="{ 'tw-font-bold': fontBold }"
    :style="{
      width: `${width}px`,
      height: `${height}px`,
      'background-color': !props.isActive ? props.nonActiveColor : stringToHex(stringColor),
    }"
  >
    {{ abbr }}
    <slot name="user-icon-letter" />
  </div>
</template>
